import React from 'react';
import { Table } from "reactstrap";
import RedirectToLive from '../containers/RedirectToLive';

const ttResults = (props) => {
  const {
    EventName,
    ttResults,
    fase,
    noColumnas,
    ExecuteUpdate
  } = props;

  const content = ttResults.map((item, i) =>
    <tr key={i}>
      <td>{item.Rank}</td>
      <td>{item.Bib}</td>
      <td>{item.Name}</td>
      {/* <td>{item.Nat}</td> */}
      <td>
        <img
          src={process.env.PUBLIC_URL + '/Flags/' + item.Nat + '.bmp'}
          height="25"
          width="60"
          alt={item.Nat}
        />
      </td>
      {(noColumnas === 1 || noColumnas === 2 || noColumnas === 3) && <td>{item.Int1 && item.Int1.split(/(?:\r\n|\r|\n)/g).map((r, i) => (<div key={i}>{r} <br></br></div>))}</td>}
      {(noColumnas === 2 || noColumnas === 3) && <td>{item.Int2 && item.Int2.split(/(?:\r\n|\r|\n)/g).map((r, i) => (<div key={i}>{r} <br></br></div>))}</td>}
      {noColumnas === 3 && <td>{item.Int3 && item.Int3.split(/(?:\r\n|\r|\n)/g).map((r, i) => (<div key={i}>{r} <br></br></div>))}</td>}
      <td>{item.Final && item.Final.split(/(?:\r\n|\r|\n)/g).map((r, i) => (<div key={i}>{r} <br></br></div>))}</td>
      <td>{item.Diff}</td>
      <td>{item.Speed}</td>
    </tr>
  );

  const TTResultsTable = () => {
    return (
      <div className="container">
        <h2>{EventName} {fase === "0" ? "Qualification" : fase === "2" ? "Finals" : ""} Results</h2>
        <br />
        <Table>
          <thead>
            <tr>
              <th>Rank</th>
              <th>Bib</th>
              <th>Name</th>
              <th>Nat</th>
              {(noColumnas === 1 || noColumnas === 2 || noColumnas === 3) && <th>Int1</th>}
              {(noColumnas === 2 || noColumnas === 3) && <th>Int2</th>}
              {noColumnas === 3 && <th>Int3</th>}
              <th>Final</th>
              <th>Diff</th>
              <th>Speed</th>
            </tr>
          </thead>
          <tbody>
            {content}
          </tbody>
        </Table>
        <br />
        <br />
      </div>
    );
  }

  return (
    <div>
      <RedirectToLive Update={ExecuteUpdate} />
      <TTResultsTable />
    </div>

  );
};

export default ttResults;  